import type { ContractTemplateAssignment } from 'global-intern-types';

export const VORLAGEN_ARTEN = {
  contract: 'Vertrag',
  dispatch_letter: 'Anschreiben Versand',
  return_letter: 'Anschreiben Rücksendung',
};

export const VORLAGEN_GESCHLECHTER = {
  female: 'Beraterin',
  male: 'Berater',
  // RITA-1584: Die Vorlage gilt für Beraterin oder Berater; die Anrede passt sich über Platzhalter an.
  // Hieß bis RITA-1569 „beide“, bis RITA-1584 „Beraterin und Berater“; gespeichert bleibt `both`.
  both: 'Berater/in – automatisch',
  company: 'Firma als Vertragspartner',
};

export interface VorlagenZuordnungForm {
  art: string;
  firma: string;
  vertragsart: string;
  fuer: string;
}

export type Zuordnungsfehler = Partial<Record<keyof VorlagenZuordnungForm, string>>;

export function zuordnungZumFormular(assignment?: ContractTemplateAssignment | null): VorlagenZuordnungForm {
  if (!assignment) return { art: '', firma: '', vertragsart: '', fuer: '' };
  return {
    art: assignment.kind,
    firma: String(assignment.branch_office_id),
    vertragsart: String(assignment.contract_type_id),
    fuer: assignment.gender,
  };
}

function positiveId(value: string): boolean {
  return /^\d+$/.test(value) && Number.isSafeInteger(Number(value)) && Number(value) > 0;
}

export function pruefeZuordnung(wert: VorlagenZuordnungForm): Zuordnungsfehler {
  const fehler: Zuordnungsfehler = {};
  if (!Object.prototype.hasOwnProperty.call(VORLAGEN_ARTEN, wert.art)) fehler.art = 'Bitte eine Art auswählen';
  if (!positiveId(wert.firma)) fehler.firma = 'Bitte eine Firma auswählen';
  // RITA-1572: Jede Vorlage gilt für genau eine Vertragsart; „alle Vertragsarten“ gibt es nicht mehr.
  if (!positiveId(wert.vertragsart)) {
    fehler.vertragsart = 'Bitte eine Vertragsart auswählen';
  } else if (wert.vertragsart === '3' && wert.firma !== '1') {
    fehler.vertragsart = 'Pro Holidays ist nur für Mein Urlaubsglück möglich';
  }
  if (wert.fuer === 'company' && wert.art !== 'contract') {
    fehler.fuer = 'Firma als Vertragspartner ist nur für Verträge möglich';
  } else if (!Object.prototype.hasOwnProperty.call(VORLAGEN_GESCHLECHTER, wert.fuer)) {
    // RITA-1569: Die Auswahlliste nennt die Möglichkeiten selbst; eine Aufzählung aller Möglichkeiten
    // läse sich holprig.
    fehler.fuer = 'Bitte auswählen, für wen die Vorlage gilt';
  }
  return fehler;
}

export function zuordnungZumInput(wert: VorlagenZuordnungForm) {
  return {
    kind: wert.art,
    branch_office_id: Number(wert.firma),
    contract_type_id: Number(wert.vertragsart),
    gender: wert.fuer,
  };
}
